import React from 'react';
import TopPanel from "./toppanel.js";

module.exports = React.createClass({
    success: function(reply) {
        if (!this.mountState)
            return;
        var inputFile = $('#feedbackFile');
        inputFile.replaceWith(inputFile = inputFile.clone(true));
        this.setState({data: this.getEmptyData()});
        HC_ShowMessage("Your feedback is successfully sent");
    },


    getInitialState: function () {
        return {
            feedbackTypes: ['Comment', 'Proposal', 'Bug'],
            data: this.getEmptyData(),
            afterFailState: false
        }
    },

    getEmptyData: function () {
        return {type:'Comment', text:''};
    },

    componentDidMount: function () {
        this.mountState = true;
        HC_RestoreNavPanel();
        HC_SelectNavItem("li-feedback");
        HC_SubscribeHammerEvent(this.refs.hc_feedback, "swiperight", HC_ToggleNavPanel);

    },
    componentWillUnmount: function () {
        this.mountState = false;
        HC_UnsubscribeHammerEvent(this.refs.hc_feedback, "swiperight")
    },
    sendFeedback: function () {
        if (HC_Validate()) {
            this.state.afterFailState = false;
            HC_SendRequest('send_feedback', this.state.data, this.success);
        }
    },

    fieldChanged: function (o) {
        this.state.data[o.target.getAttribute('data-key')] = o.target.value;
        HC_Validate(o.target, !this.state.afterFailState);
        this.setState({data: this.state.data});
    },

    openFile: function (e) {
        var input = e.target;
        var reader = new FileReader();
        reader.onload = function(){
            this.state.data.file_content = reader.result;
        }.bind(this);
        if (input.files.length > 0) {
            this.state.data.file_content = null;
            this.state.data.file_name = input.files[0].name;
            reader.readAsDataURL(input.files[0]);
        }
    },

    render: function () {
        var i = 0;
        var types = this.state.feedbackTypes.map(function (s) {
            return (<option key={++i} value={s}>{s}</option>);
        });
        var disableAttach = window.cordova == undefined;

        return (
            <div style={{position:'relative', width:'100%', height:'100%'}}>
                <TopPanel text={HC_LANG.NAV_FEEDBACK} licon="fa-bars" onLiconClick={HC_ToggleNavPanel}/>
                <div ref="hc_feedback" style={{padding:"5%", paddingTop:"3%", position:"absolute", left:0, right:0, top:"60px", bottom:0, overflowY: "auto", WebkitOverflowScrolling:'touch'}}>
                    <div className="hc-f2">Send your feedback</div>
                    <select className="form-control hc-f4 hc-validated"
                            style={{width:'100%', marginTop:'1rem'}} data-key="type"  data-vfunc="HC_ValidateNotEmptyField"
                            value={this.state.data.type} onChange={this.fieldChanged}>
                        {types}
                    </select>
                    <textarea className="form-control hc-f4 hc-validated"
                              style={{width: "100%", maxHeight:"500px", height:"150px", marginTop:'1rem', resize:"vertical"}}
                              data-key="text" data-vfunc="HC_ValidateNotEmptyField"
                              value={this.state.data.text} onChange={this.fieldChanged}/>
                    <div className="hc-f4" style={{marginTop:"1rem", display: (disableAttach ? "block" : "none" )}}>
                        Attachment (optional)
                    </div>
                    <input id="feedbackFile" type='file' accept='*' onChange={this.openFile}
                           style={{marginTop:"0.5rem", display: (disableAttach ? "block" : "none" )}}/>
                    <button className="hc-button" style={{marginTop:'2rem', marginBottom:'2rem'}} onClick={this.sendFeedback}>Send</button>
                </div>
            </div>
        );
    }
});


// WEBPACK FOOTER //
// ./feedback.js